import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'
import { CookieService } from 'ngx-cookie-service'

@Injectable({
  providedIn: 'root',
})
export class WebViewService {
  public current = false
  private subject = new BehaviorSubject(this.current)

  constructor(
    private cookieService: CookieService
  ) { }

  public get current$(): Observable<boolean> {
    return this.subject.asObservable()
  }

  public loadCurrent(): void {
    this.setCurrent(this.cookieService.get('webView') === '1')
  }

  public setCurrent(next: boolean): void {
    const hasCookie = this.cookieService.check('webView')
    if (next && !hasCookie) {
      this.cookieService.set('webView', '1', { path: '/' })
    }
    else if (!next && hasCookie) {
      this.cookieService.delete('webView', '/')
    }
    this.subject.next(next)
    this.current = next
  }
}
